import type React from 'react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { OperationsPageView } from './OperationsPageView';
import { useOperationsPage } from './useOperationsPage';

/**
 * `/accounting/operations` — the tab shell every `/accounting/operations*` URL
 * renders.
 *
 * The fifth Accounting grouping, and the one that spans the other four: an
 * operation is how a figure gets into the ledger at all. Templates is the
 * catalog of every way that happens — the flows BosApi already posts from code,
 * read-only, alongside the tenant's own editable ones. Record and Activity land
 * in tasks 03 and 04.
 *
 * Each tab owns its data and its own `ErrorBoundary`, so this shell holds
 * neither.
 */
export const OperationsPage: React.FC = () => {
    const page = useOperationsPage();

    return (
        <div
            className="flex w-full flex-col gap-6"
            {...getNodeTestIdProp('operations-page')}
        >
            <OperationsPageView
                selectedTabId={page.selectedTabId}
                tabs={page.tabs}
            />
        </div>
    );
};
